<template>
  <v-container fluid class="pa-0">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <AboutUSBannerDetail />
    <Card />
    <ServiceSupport />
    <ProjectHighlight />

  </v-container>
</template>

<script>
import AboutUSBannerDetail from "@/components/AboutUS/AboutUSBannerDetail.vue";
import Card from "@/components/AboutUS/Card.vue";
import ServiceSupport from "@/components/AboutUS/ServiceSupport.vue";
import ProjectHighlight from "@/components/AboutUS/ProjectHighlight.vue";


export default {
  name: "AboutUS",
  components: { AboutUSBannerDetail, Card, ServiceSupport, ProjectHighlight },
  data() {
    return { isLoading: false };
  },
};
</script>

<style scoped>
.v-container {
  padding: 0 !important;
}
</style>
